import React, { createContext } from 'react';

import { TAlertMessage, useAlertMessage } from '@/Utils/useAlertMessage';

export const BookingProviderContext = createContext<{
  alertMessage: TAlertMessage | null;
  showAlert: (params: TAlertMessage) => void;
}>(null as any); // eslint-disable-line @typescript-eslint/no-explicit-any

export const BookingProvider = ({ children, ...props }) => {
  const { alertMessage, showAlert } = useAlertMessage(false);

  return (
    <BookingProviderContext.Provider
      value={{
        ...props,
        alertMessage,
        showAlert,
      }}
    >
      {children}
    </BookingProviderContext.Provider>
  );
};
